import React, { createContext } from 'react';
import { MIN_WIDTH_DESKTOP } from './presentational/constants';

type HeaderContextShape = {
  siteSource: string;
  loginData: {
    logged_in: boolean;
    user_role?: string;
    inspiration_board_web_path?: string;
    number_messages?: number;
    user_thumbnail?: string;
  };
  hasSearch: boolean;
  shouldShowActions?: boolean;
  breakPoint: string;
};

const HeaderContext = createContext<HeaderContextShape>({
  siteSource: '',
  loginData: { logged_in: false },
  hasSearch: false,
  shouldShowActions: true,
  breakPoint: MIN_WIDTH_DESKTOP,
});

export const HeaderContextProvider: React.FC<HeaderContextShape> = ({
  children,
  siteSource,
  loginData,
  hasSearch,
  breakPoint,
  shouldShowActions,
}) => (
  <HeaderContext.Provider
    value={{
      siteSource,
      loginData,
      hasSearch,
      shouldShowActions,
      breakPoint,
    }}
  >
    {children}
  </HeaderContext.Provider>
);

export default HeaderContext;
